/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1SerievideoVideoidLangsId202,
  DeleteApiV1SerievideoVideoidLangsId401,
  DeleteApiV1SerievideoVideoidLangsId404,
  DeleteApiV1SerievideoVideoidLangsId500,
  DeleteApiV1SerievideoVideoidLangsIdMutationResponse,
  DeleteApiV1SerievideoVideoidLangsIdPathParams,
  DeleteApiV1SerievideoVideoidLangsIdQueryParams,
} from "../../types/serieVideoIdiomasController/DeleteApiV1SerievideoVideoidLangsId.ts";

export const deleteApiV1SerievideoVideoidLangsIdPathParamsSchema = z.object({
  videoId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1SerievideoVideoidLangsIdPathParams>;

export const deleteApiV1SerievideoVideoidLangsIdQueryParamsSchema = z
  .object({
    serieId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<DeleteApiV1SerievideoVideoidLangsIdQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1SerievideoVideoidLangsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerievideoVideoidLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1SerievideoVideoidLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerievideoVideoidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1SerievideoVideoidLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerievideoVideoidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1SerievideoVideoidLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerievideoVideoidLangsId500>;

export const deleteApiV1SerievideoVideoidLangsIdMutationResponseSchema = z.lazy(
  () => deleteApiV1SerievideoVideoidLangsId202Schema,
) as unknown as ToZod<DeleteApiV1SerievideoVideoidLangsIdMutationResponse>;
